function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { toggle_loader, disable_loader } from '../../../src/js/loader.js';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import Toastify from 'toastify-js'; //we'll fetch the endpoint to query based on the display method

var endpoint = false; //defines our variables for the map and list elements

var installersMap = false;
var installersList = false;
var installersForm = false;
var installersEnquire = false; //array to hold the map pins

var markers = []; //bool to determine if the display installers function has been called

var installers_rendering = false; //variable to hold the last time we checked for existing quotes

var lastCheckTime = 0; //add a variable to determine if we should use local caching

var local_caching = false; //define a variable to hold product images

var product_images = false; //defien a variable to hold product urls

var product_urls = false; //define a variable to hold our active products

var active_products = false; //define a variable to hold localization strings

var localization = false;
document.addEventListener("DOMContentLoaded", function () {
  //if we have our ajax object defined
  if (typeof installers_ajax_object !== 'undefined') {
    //set our active products
    active_products = installers_ajax_object.active_products; //set our localization strings

    localization = installers_ajax_object.localization;
  } //fetch the installer map element


  installersMap = document.getElementById("installersMap"); //fetch the installer list element

  installersList = document.getElementById("installersList"); //fetch the installer list element

  installersForm = document.getElementsByClassName("installer-form-block"); //fetch the installer enquire only element

  installersEnquire = document.getElementsByClassName("installers-enquire-only"); //if the installer map, list or block element exists

  if (installersMap || installersList || installersForm) {
    //initialize our quote handler
    init_quote_handler(); //if we're displaying using the map

    if (installersMap) {
      //fetch the endpoint from the map
      endpoint = installersMap.dataset.endpoint; //initialize the map

      init_map();
    } else if (installersList) {
      //fetch the endpoint from the map
      endpoint = installersList.dataset.endpoint;
    } //if we have a map or list


    if (installersMap || installersList) {
      var _document$querySelect;

      //attempt to fetch the search form
      var form = (_document$querySelect = document.querySelector('.installer-manual-search')) !== null && _document$querySelect !== void 0 ? _document$querySelect : false; //get the installers (providing the form if it contains a valid location)

      get_installers(form ? form.querySelector('#installer-search-location').value ? form : false : false); //add a click event listener to the document

      document.addEventListener("click", function (event) {
        //if this isn't the button to close the no results modal, return
        if (!event.target.id || event.target.id !== 'installers-no-results-close') return; //close the no results modal

        close_no_results();
      });
    } //if we have an enquire only form


    if (installersEnquire) {
      //add a click event listener to the document
      document.addEventListener("click", function (event) {
        //if this isn't the .installers-enquire-only-product button, return
        if (!event.target.closest('.installers-enquire-only-product')) return; //get our installer and product info

        var installer_id = event.target.closest('.installers-enquire-only-product').dataset.installer_id;
        var installer_name = event.target.closest('.installers-enquire-only-product').dataset.installer_name;
        var product = event.target.closest('.installers-enquire-only-product').dataset.product; //open the enquire modal, passing our installer and product info

        open_enquire(installer_id, installer_name, product);
      }); //add a click event listener to the document

      document.addEventListener("click", function (event) {
        //if this isn't the button to close the enquire modal, return
        if (!event.target.id || event.target.id !== 'installers-enquire-only-close') return; //close the enquire modal

        close_enquire();
      });
    }
  }
});

function get_installers() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  //toggle our loader
  toggle_loader(); //attempt to find our quote ID

  var quote_id = document.getElementById('quote_id').value; //create a default request slug

  var request_slug = endpoint + (quote_id ? '?quote=' + quote_id : ''); //define our variables

  var location, proximity, zappi, zappi_glo, eddi, libbi; //if we have a form

  if (form) {
    var _form$querySelector$v, _form$querySelector$v2, _form$querySelector$c, _form$querySelector$c2, _form$querySelector$c3, _form$querySelector$c4;

    //fetch the location and proximity from the form
    location = (_form$querySelector$v = form.querySelector('#installer-search-location').value) !== null && _form$querySelector$v !== void 0 ? _form$querySelector$v : 'DN41 8FF';
    proximity = (_form$querySelector$v2 = form.querySelector('#installer-search-proximity').value) !== null && _form$querySelector$v2 !== void 0 ? _form$querySelector$v2 : 100; //fetch the zappi, eddi and libbi checkboxes from the form

    zappi = form.querySelector('#installer-search-zappi') ? (_form$querySelector$c = form.querySelector('#installer-search-zappi').checked) !== null && _form$querySelector$c !== void 0 ? _form$querySelector$c : false : false;
    zappi_glo = form.querySelector('#installer-search-zappi-glo') ? (_form$querySelector$c2 = form.querySelector('#installer-search-zappi-glo').checked) !== null && _form$querySelector$c2 !== void 0 ? _form$querySelector$c2 : false : false;
    eddi = form.querySelector('#installer-search-eddi') ? (_form$querySelector$c3 = form.querySelector('#installer-search-eddi').checked) !== null && _form$querySelector$c3 !== void 0 ? _form$querySelector$c3 : false : false;
    libbi = form.querySelector('#installer-search-libbi') ? (_form$querySelector$c4 = form.querySelector('#installer-search-libbi').checked) !== null && _form$querySelector$c4 !== void 0 ? _form$querySelector$c4 : false : false; // build up a longer request slug

    request_slug = endpoint + '?' + (location ? 'location=' + location + '&' : '') + (proximity ? 'proximity=' + proximity + '&' : '') + (zappi ? 'zappi=true&' : '') + (zappi_glo ? 'zappi_glo=true&' : '') + (eddi ? 'eddi=true&' : '') + (libbi ? 'libbi=true&' : '');
  } //default to not fetching cached results


  var cached_installers = false; //if the site we're on is not local

  if (local_caching || window.location.hostname !== 'myenergi.local') {
    //attempt to fetch the cached installers from session storage
    cached_installers = sessionStorage.getItem(request_slug);
  } //if we have a cached response


  if (cached_installers) {
    var _installersMap;

    //parse the cached response
    var installers = JSON.parse(cached_installers);

    if (installers.error) {
      display_error(installers.error);
      return;
    } //save our product images


    product_images = installers.product_images; //save our product urls

    product_urls = installers.product_urls; //display the installers

    display_installers(installers.data, installers.origin, proximity, installers.default, (_installersMap = installersMap) !== null && _installersMap !== void 0 ? _installersMap : installersList);
  } else {
    //otherwise we need to make a new request
    //create a new request
    var xhttp = new XMLHttpRequest(); //when the request state changes

    xhttp.onreadystatechange = function () {
      //if our request is complete
      if (this.status === 200) {
        //default to no installers
        var _installers = false; //try...

        try {
          var _installersMap2;

          //... to parse the response
          _installers = JSON.parse(xhttp.responseText);

          if (_installers.error) {
            display_error(_installers.error);
            return;
          } //save our product images


          product_images = _installers.product_images; //display the installers

          display_installers(_installers.data, _installers.origin, proximity, _installers.default, (_installersMap2 = installersMap) !== null && _installersMap2 !== void 0 ? _installersMap2 : installersList); //if this isn't a local environment

          if (local_caching || window.location.hostname !== 'myenergi.local') {
            //cache this response in session using the request_slug as the key
            sessionStorage.setItem(request_slug, JSON.stringify(_installers));
          } //prevent this from running again


          xhttp.onreadystatechange = null;
        } catch (error) {//if there's an error...
          //ignore it, we don't need to do anything
        }
      }
    }; //open the request


    xhttp.open("GET", request_slug, true); //if we have a map

    if (installersMap) {
      //clear all the markers
      for (var i = 0; i < markers.length; i++) {
        //set the map to null
        markers[i].setMap(null);
      } //empty the markers array


      markers = [];
    } else if (installersList) {
      //otherwise if we have a list
      //empty the list
      installersList.innerHTML = ''; //adds 8 skeleton loaders

      for (var _i = 0; _i < 8; _i++) {
        //add a skeleton loader
        installersList.innerHTML += "<nb-skeleton class=\"block h-24 w-full rounded-3xl overflow-hidden mb-2\"></nb-skeleton>";
      }
    } //send the request


    xhttp.send();
  }
}

function init_map() {
  var _installersMap$getAtt;

  //create a variable to hold the map
  window.installer_map = false; //get the latitude and longitude from the data attributes

  var lat = parseFloat(installersMap.getAttribute("data-lat"));
  var lng = parseFloat(installersMap.getAttribute("data-lng")); //fetch our pin grouping from the data attribute

  window.installer_map_pin_grouping = (_installersMap$getAtt = installersMap.getAttribute("data-pin_grouping")) !== null && _installersMap$getAtt !== void 0 ? _installersMap$getAtt : 'false'; //cast the pin grouping to a boolean

  window.installer_map_pin_grouping = window.installer_map_pin_grouping === 'true' || window.installer_map_pin_grouping === true; //initialize the map

  window.installer_map = new google.maps.Map(document.getElementById("installersMap"), {
    center: {
      lat: lat,
      lng: lng
    },
    zoom: 3,
    mapTypeControl: false,
    streetViewControl: false,
    minZoom: 9,
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.TOP_RIGHT
    },
    zoomControl: true,
    fullscreenControl: false,
    styles: [{
      featureType: "all",
      elementType: "labels",
      stylers: [{
        visibility: "off"
      }]
    }, {
      featureType: "road",
      elementType: "labels",
      stylers: [{
        visibility: "off"
      }]
    }]
  });
}

function display_installers(installers, origin, proximity, default_search, container) {
  //if we're already rendering, bail
  if (installers_rendering) return; //set this to true

  installers_rendering = true; //determine which view we're rendering

  var view = container.getAttribute('id') == 'installersMap' ? 'map' : 'list'; //if we have some installers to display

  if (installers) {
    //if we have no results
    if (installers.length === 0) {
      //open the no results modal
      open_no_results(); //wait 5s

      setTimeout(function () {
        //close the no results modal
        close_no_results();
      }, 5000);
    } //if we're rendering as a map


    if (view === 'map') {
      //we'll store our positions here to quickly check for overlaps
      var marker_positions = [];
      /**
       Add pins for the installers
      */

      var _loop = function _loop(i) {
        //fetch our data
        var data = installers[i]; //create our standard icon

        var icon = {
          url: installers_script_vars.theme_path + '/graphics/installers/pin.svg',
          origin: new google.maps.Point(0, 0),
          // origin
          scaledSize: new google.maps.Size(28, 43)
        }; //create our active icon

        var activeIcon = {
          url: installers_script_vars.theme_path + '/graphics/installers/pin-active.svg',
          scaledSize: new google.maps.Size(28, 43)
        }; //create our quoted icon

        var quotedIcon = {
          url: installers_script_vars.theme_path + '/graphics/installers/pin-quoted.svg',
          scaledSize: new google.maps.Size(28, 43)
        }; //keep track of the original icon

        var originalIcon = icon; //check to see if we have a pin in this position already, if we do we need to change the position to be close by but not overlapping

        if (marker_positions.includes(data['lat'] + ',' + data['lng'])) {
          //small offset to avoid overlap
          var offset = 0.0001; //ensure lat/lng remain valid numbers and within typical bounds

          var newLat = parseFloat((parseFloat(data['lat']) + offset * (Math.random() > 0.5 ? 1 : -1)).toFixed(6));
          var newLng = parseFloat((parseFloat(data['lng']) + offset * (Math.random() > 0.5 ? 1 : -1)).toFixed(6)); //clamp latitude to -90..90 and longitude to -180..180

          newLat = Math.max(-90, Math.min(90, newLat));
          newLng = Math.max(-180, Math.min(180, newLng)); //update the data with the new position

          data['lat'] = newLat;
          data['lng'] = newLng;
        } //add the position to our marker positions


        marker_positions.push(data['lat'] + ',' + data['lng']); //add the marker to the map

        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(data['lat'], data['lng']),
          //get the first and second items (latitude and longitude)
          map: window.installer_map,
          optimized: false,
          icon: icon
        }); //set the default icon

        marker['originalIcon'] = originalIcon; //add identifier to the marker

        marker['installerId'] = data['data']['id']; //push the marker to our markers array

        markers.push(marker); //create the info window for this marker

        var infoWindow = new google.maps.InfoWindow({
          content: '<div class="installer-info">' + render_item(data, view, default_search) + '</div>'
        }); //add the info window to the marker

        marker.infoWindow = infoWindow; //register a click event listener for the marker

        google.maps.event.addListener(marker, 'click', function (marker, i) {
          return function () {
            //check if the info window is already open
            if (infoWindow.getMap()) {
              //close the info window
              infoWindow.close(); //if the marker is not already quoted

              if (marker.getIcon().url !== quotedIcon.url) {
                //set the icon back to the original icon
                marker.setIcon(marker['originalIcon']);
              }
            } else {
              //close all info windows first
              for (var j = 0; j < markers.length; j++) {
                //if the info window is open
                if (markers[j].infoWindow) {
                  //close it
                  markers[j].infoWindow.close(); //if the marker is not already quoted

                  if (markers[j].getIcon().url !== quotedIcon.url) {
                    //set the icon back to the original icon
                    markers[j].setIcon(markers[j]['originalIcon']);
                  }
                }
              } //open the info window


              infoWindow.open(window.installer_map, marker); //if the marker is not already quoted

              if (marker.getIcon().url !== quotedIcon.url) {
                //set the active icon
                marker.setIcon(activeIcon);
              } //allow time for the info window to render


              setTimeout(function () {
                //quickly check for existing cached quotes
                check_existing_quotes(true);
              }, 10);
            }
          };
        }(marker, i));
        console.log('how many installers', installers.length); //if we only have one installer available

        if (installers.length === 1) {
          //change the origin to this installer
          origin = {
            lat: data['lat'],
            lng: data['lng']
          }; //open the info window by default

          infoWindow.open(window.installer_map, marker);
        }
      };

      for (var i = 0; i < installers.length; i++) {
        _loop(i);
      } //update our global markers variable


      window.installer_markers = markers; //if we have an origin

      if (origin) {
        var _installersMap$datase;

        //re-center the map
        window.installer_map.setCenter(new google.maps.LatLng(origin['lat'], origin['lng'])); //re-zoom the map

        window.installer_map.setZoom(10); //if we have an existing radius circle...

        if (window.installer_origin_circle) {
          //remove it
          window.installer_origin_circle.setMap(null);
        } //fetch the unit from the dataset, defaulting to 'M' (miles)


        var unit = (_installersMap$datase = installersMap.dataset.unit) !== null && _installersMap$datase !== void 0 ? _installersMap$datase : 'M'; //convert proximity from miles to meters (kilometers to meters)

        var unitProximity = proximity * (unit === 'M' ? 1609.34 : 1000); //add a circle to the map to indicate the origin

        window.installer_origin_circle = new google.maps.Circle({
          strokeColor: "#000000",
          strokeOpacity: 0.6,
          strokeWeight: 2,
          fillColor: "#000000",
          fillOpacity: 0.10,
          map: window.installer_map,
          center: {
            lat: origin['lat'],
            lng: origin['lng']
          },
          radius: unitProximity
        });
      } //check if we have any existing quotes


      check_existing_quotes(); //require our debounce function

      var debounce = require('debounce'); //add event listeners to the map to hide unecessary markers when not in view


      google.maps.event.addListener(window.installer_map, "dragend", debounce(hide_markers), 150);
      google.maps.event.addListener(window.installer_map, "zoom_changed", debounce(hide_markers), 150); //trigger the hide markers function now

      hide_markers(); //if pin grouping is enabled

      if (window.installer_map_pin_grouping) {
        //group the markers
        group_markers();
      }
    } else {
      //otherwise it's the list view
      //if we have some installers to render
      if (installers.length > 0) {
        var hide_pc_ids = view === 'map' ? document.getElementById('installersMap').dataset.hide_pc_id === 'true' : document.getElementById('installersList').dataset.hide_pc_id === 'true'; //loop over each installer

        for (var _i2 = 0; _i2 < installers.length; _i2++) {
          //fetch our data
          var data = installers[_i2]; //if this is the first item to render...

          if (_i2 === 0) {
            var _container$dataset$te, _container$dataset$te2;

            //fetch our title and description
            var title = (_container$dataset$te = container.dataset.text_title) !== null && _container$dataset$te !== void 0 ? _container$dataset$te : false;
            var description = (_container$dataset$te2 = container.dataset.text_description) !== null && _container$dataset$te2 !== void 0 ? _container$dataset$te2 : false; //add our header

            container.innerHTML = "<div class=\"md:col-span-2\">\n                            <h2 class=\"text-[22px] lg:text-[31px] ".concat(data['type'] === 'product-champions' ? '!my-0' : '!mt-0 !mb-5', "\">\n                                ").concat(title ? title : 'Your nearest installers', "\n                            </h2>\n                            ").concat(data['type'] === 'product-champions' ? "<p class=\"!mt-2 !mb-5 text-sm md:text-base\">\n                                ".concat(description ? description : "You can request as many quotes as you like. We'll send your details to the installers you select and they'll get in touch with you directly.", "\n                            </p>") : '', "\n                        </div>");
          } //append the item to the container


          container.innerHTML += "<div class=\"installers-list-item bg-white border border-[#C5C5C5] w-full flex flex-wrap 2xl:flex-nowrap px-4.5 xl:pl-6 xl:pr-7 py-5 xl:py-3.5 space-y-2 2xl:space-y-0 xl:space-x-2 rounded-2.5xl lg:mb-3.5 justify-between ".concat(!hide_pc_ids ? '2xl:justify-normal' : 'lg:justify-normal', " items-start xl:items-center\" data-slug=\"").concat(data['data']['slug'], "\">") + render_item(data, view, default_search) + "</div>";
        }
      } else {
        //wipe the container so the skeleton loaders are removed
        container.innerHTML = '';
        var no_results_heading = document.querySelector('#installers-no-results h2');
        var no_results_description = document.querySelector('#installers-no-results p'); //if we have no results heading and description

        if (no_results_heading && no_results_description) {
          //make sure these span the full width of the container
          no_results_heading.classList.add('col-span-2');
          no_results_description.classList.add('col-span-2'); //add the heading and description from the no results modal

          container.appendChild(no_results_heading.cloneNode(true));
          container.appendChild(no_results_description.cloneNode(true));
        }
      } //check if we have any existing quotes


      check_existing_quotes();
    } //indicate we're no longer rendering


    installers_rendering = false;
  }

  disable_loader();
}

function display_error(message) {
  //remove the loader element
  disable_loader(); //open the no results modal with a custom message

  open_no_results(message);
}

function render_item(item, view, default_search) {
  var _document$querySelect2, _logo, _item$data$name, _item$data$city, _item$data$zip, _item$data$website, _item$data$domain, _item$data$email, _item$data$email2;

  //attempt to find our quote ID from the URL
  var urlParams = new URLSearchParams(window.location.search);
  var quote_id = urlParams.get('quote'); //define a default (empty) logo

  var logo = '';
  var logo_fallback = ''; //define our path to the approved logo

  var approved = '/wp-content/themes/myenergi-multisite/graphics/installers/myenergi-approved.png'; //if we have a logo

  if (item['data']['logo']) {
    //set the logo
    logo = item['data']['logo'];
  } //if we have a fallback logo


  if (item['data']['logo_fallback']) {
    //set the logo
    logo_fallback = item['data']['logo_fallback'];
  } //define this as false initially


  var form_page = false; //depending on the view we're currently using

  switch (view) {
    case 'map':
      //fetch the form page
      form_page = document.getElementById('installersMap').dataset.form_page;
      break;

    case 'list':
      //fetch the form page
      form_page = document.getElementById('installersList').dataset.form_page;
      break;
  } //fetch all inputs of the "product_type" checkboxes (if they exist)


  var filtered_products = (_document$querySelect2 = document.querySelectorAll('input[name="product_type[]"]:checked')) !== null && _document$querySelect2 !== void 0 ? _document$querySelect2 : []; //if we have some inputs

  if (filtered_products && filtered_products.length > 0) {
    //create an array to hold the values
    var values = []; //loop through each input

    filtered_products.forEach(function (input) {
      //add the value to the array
      values.push(input.value);
    }); //set the filtered products to the values

    filtered_products = values;
  } else {
    //redefine the filtered products as an empty array
    filtered_products = [];
  }

  var installer_products = {
    'zappi': {
      'type': 'zappi',
      'label': 'zappi',
      'available': item['products']['zappi'] === 'Yes' && (filtered_products.length === 0 || filtered_products.includes('zappi')) && (!active_products || active_products['zappi'])
    },
    'zappi_glo': {
      'type': 'glo',
      'label': 'zappi GLO',
      'available': item['products']['zappi_glo'] === 'Yes' && (filtered_products.length === 0 || filtered_products.includes('zappi_glo')) && (!active_products || active_products['zappi_glo'])
    },
    'eddi': {
      'type': 'eddi',
      'label': 'eddi',
      'available': item['products']['eddi'] === 'Yes' && (filtered_products.length === 0 || filtered_products.includes('eddi')) && (!active_products || active_products['eddi'])
    },
    'libbi': {
      'type': 'libbi',
      'label': 'libbi',
      'available': item['products']['libbi'] === 'Yes' && (filtered_products.length === 0 || filtered_products.includes('libbi')) && (!active_products || active_products['libbi'])
    },
    'harvi': {
      'type': 'harvi',
      'label': 'harvi',
      'available': item['products']['harvi'] === 'Yes' && (filtered_products.length === 0 || filtered_products.includes('harvi')) && (!active_products || active_products['harvi'])
    }
  }; //determine if this is enquire only

  var enquire_only = view === 'map' ? document.getElementById('installersMap').dataset.enquire_only === 'true' : document.getElementById('installersList').dataset.enquire_only === 'true'; //determine if we have a form that is enquire only

  var enquire_only_form = enquire_only ? document.getElementById('installersMap') && document.getElementById('installersMap').dataset.enquire_only_form === 'true' || document.getElementById('installersList') && document.getElementById('installersList').dataset.enquire_only_form === 'true' : false; //determine if we should hide PC IDs

  var hide_pc_ids = view === 'map' ? document.getElementById('installersMap').dataset.hide_pc_id === 'true' : document.getElementById('installersList').dataset.hide_pc_id === 'true'; //determine if we should hide logos

  var hide_logos = view === 'map' ? document.getElementById('installersMap').dataset.hide_logos === 'true' : document.getElementById('installersList').dataset.hide_logos === 'true'; //determine if we should hide contact details

  var hide_contact_details = view === 'map' ? document.getElementById('installersMap').dataset.hide_contact_details === 'true' : document.getElementById('installersList').dataset.hide_contact_details === 'true';
  return "\n        <div class=\"w-full flex flex-row ".concat(hide_logos && view === 'map' ? 'justify-end' : 'justify-between', " ").concat(view !== 'map' ? (!hide_pc_ids ? 'xl:w-[165px] 2xl:w-[183px]' : 'lg:w-[100px]') + ' xl:flex-col xl:justify-start xl:space-y-3.5' : 'xxsm:p-2.5', "\">\n\n            ") + (!hide_logos ? "\n            <img src=\"".concat((_logo = logo) !== null && _logo !== void 0 ? _logo : logo_fallback, "\" onerror=\"this.onerror=null;this.src='").concat(logo_fallback && logo_fallback != '' ? logo_fallback : '/wp-content/themes/myenergi-multisite/graphics/bolt.svg', "';\" class=\"installers-request-logo object-contain object-left !max-w-[85px] !max-h-[28px] ").concat(view === 'map' ? 'xxsm:!max-w-[127px] xxsm:!max-h-[46px]' : '', "\" data-id=\"").concat(item['data']['id'], "\" />\n            ") : '') + (hide_pc_ids ? '' : "\n                <a href=\"https://id.myenergi.com/en-gb/installer?id=".concat(item['data']['hs_id'], "\" target=\"_blank\" class=\"flex flex-row-reverse items-center no-underline ").concat(view !== 'map' ? 'xl:flex-row' : '', "\">\n                    <img src=\"").concat(approved, "\" class=\"!w-[36px] pointer-events-none ").concat(view === 'map' ? 'xxsm:!w-[44px]' : '', "\" />\n                    <span class=\"flex space-x-0.5 mx-1 pointer-events-none whitespace-nowrap\">\n                        <span class=\"text-[10px] py-0.5 pl-2 pr-1 leading-[12px] border border-[#010101] text-[#010101] rounded-l-full no-underline user-select-none\">ID</span>\n                        <span class=\"text-[10px] py-0.5 pl-1 pr-2 leading-[12px] border border-[#010101] text-[#010101] rounded-r-full no-underline user-select-none\">\n                            ").concat(item['data']['hs_id'], "\n                        </span>\n                    </span>\n                </a>\n            ")) + "\n        </div>\n\n        <div class=\"w-full ".concat(view === 'map' ? 'xxsm:px-2.5 xxsm:py-1.5' : 'xl:w-[315px] 2xl:w-[390px]', "\">\n\n            ").concat(item['data']['name'] != false ? "\n                <p class=\"text-black font-bold leading-normal text-[20px] !my-0\">\n                    ".concat((_item$data$name = item['data']['name']) !== null && _item$data$name !== void 0 ? _item$data$name : 'N/A', "\n                </p>\n            ") : '', "\n\n            <div class=\"mt-2 ").concat(view === 'map' ? 'xxsm:flex xxsm:space-x-2 md:space-x-0 md:justify-between' : 'flex space-x-4', "\">\n\n                ").concat(item['data']['city'] != false && item['data']['zip'] != false ? "\n                    <div class=\"w-[130px] ".concat(view === 'map' ? 'md:w-auto' : '', "\">\n                        <span class=\"block text-[14px] leading-[25px]\">\n                            <strong>\n                                ").concat((_item$data$city = item['data']['city']) !== null && _item$data$city !== void 0 ? _item$data$city : 'N/A', "\n                            </strong>\n                        </span>\n\n                        <span class=\"block text-[14px] leading-[25px]\">\n                            ").concat((_item$data$zip = item['data']['zip']) !== null && _item$data$zip !== void 0 ? _item$data$zip : 'N/A', "\n                        </span>\n                    </div>\n                ") : '', "\n\n                ") + (!hide_contact_details ? "\n                    <div>\n                        ".concat(item['data']['phone'] != false ? "\n                            <span class=\"block text-[14px] leading-[25px]\">\n                                <a href=\"tel:".concat(item['data']['phone'] && item['data']['phone'] != '' ? item['data']['phone'] : '#', "\">\n                                    ").concat(item['data']['phone'] && item['data']['phone'] != '' ? item['data']['phone'] : 'N/A', "\n                                </a>\n                            </span>\n                        ") : '', "\n\n                        ").concat(item['data']['website'] != false ? "\n                            <span class=\"block text-[14px] leading-[25px] underline\">\n                                <a href=\"".concat((_item$data$website = item['data']['website']) !== null && _item$data$website !== void 0 ? _item$data$website : '#', "\">\n                                    ").concat((_item$data$domain = item['data']['domain']) !== null && _item$data$domain !== void 0 ? _item$data$domain : 'N/A', "\n                                </a>\n                            </span>\n                        ") : item['data']['email'] != false ? "\n                            <span class=\"block text-[14px] leading-[25px] underline\">\n                                <a href=\"mailto:".concat((_item$data$email = item['data']['email']) !== null && _item$data$email !== void 0 ? _item$data$email : '#', "\">\n                                    ").concat((_item$data$email2 = item['data']['email']) !== null && _item$data$email2 !== void 0 ? _item$data$email2 : 'N/A', "\n                                </a>\n                            </span>\n                        ") : '', "\n                    </div>\n                ") : '') + "\n\n            </div>\n\n        </div>\n\n        <div class=\"flex-1 self-end pt-2 xl:pt-0 relative\">\n\n            ".concat(view !== 'map' ? quote_id ? "<button type=\"button\" class=\"installers-request-quote btn w-full !px-2 self-end\" data-id=\"".concat(item['data']['id'], "\" data-view=\"").concat(view, "\">\n                    ").concat(localization && localization.installers_card_request_a_quote ? localization.installers_card_request_a_quote : 'Request Quote', "\n                </button>") : "<button class=\"btn installers-product-quote-menu !bg-black !border-black !text-white !text-base !py-2.5 !px-2 self-end w-full leading-4 !mb-0.5\">\n                    <span class=\"block translate-y-0.5\">\n                        " + (enquire_only && !enquire_only_form || item['type'] == 'installer' ? localization && localization.installers_card_button_available_products ? localization.installers_card_button_available_products : 'View available products' : localization && localization.installers_card_button_select_for_quote ? localization.installers_card_button_select_for_quote : 'Select product for quote') + "\n                    </span>\n                </button>" : '', "\n\n            <div id=\"tooltip-id-").concat(item['data']['id'], "\" class=\"").concat(view === 'map' ? 'block border-t border-grey-30 mt-2 pt-4 px-2' : 'bg-black w-[374px] max-w-[calc(100%+2.25rem)] md:max-w-none p-6 absolute -bottom-4 left-1/2 -translate-x-1/2 translate-y-full rounded-4xl z-20 shadow-2xl hidden', "\">\n\n                ").concat(!quote_id && view !== 'map' ? "\n                    <div class=\"absolute -top-2 left-1/2 -translate-x-1/2 w-6 h-6 bg-black rounded-[0.25rem] rotate-45\"></div>\n                " : !quote_id ? "\n                    <p class=\"text-black font-semibold leading-normal text-[18px] !mt-0 !mb-3 px-1\">\n                        " + (enquire_only && !enquire_only_form || item['type'] == 'installer' ? localization && localization.installers_card_available_products ? localization.installers_card_available_products : 'Available Products:' : localization && localization.installers_card_request_a_quote ? localization.installers_card_request_a_quote : 'Request a quote:') + "\n                    </p>\n                " : "", "\n\n                ").concat(quote_id ? "<button type=\"button\" class=\"installers-request-quote btn w-full !px-2 self-end\" data-id=\"".concat(item['data']['id'], "\" data-view=\"").concat(view, "\">\n                    ") + (localization && localization.installers_card_quote_button ? localization.installers_card_quote_button : 'Request Quote') + "\n                </button>" : "<div class=\"grid grid-cols-2 gap-4\">\n\n                    ".concat(Object.entries(installer_products).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        productName = _ref2[0],
        details = _ref2[1];

    //check if installer offers this product
    if (details.available) {
      //define our shared classes
      var shared_classes = 'block text-center relative pt-3 rounded-2xl aspect-square ' + (view == 'map' ? 'bg-greylight' : 'bg-white'); //define our default open and close tags

      var tag_open = "<a href=\"".concat(form_page, "?product_type=").concat(details.type, "&installer=").concat(item['data']['id'], "\" class=\"installers-loading-toggle ").concat(shared_classes, "\" data-view=\"").concat(view, "\">");
      var tag_close = '</a>'; //if this is enquire only, we need to change the tags

      if (enquire_only) {
        var _item$data$name2;

        tag_open = "<" + (enquire_only_form ? 'button type="button"' : 'div') + " data-installer_id=\"".concat(item['data']['id'], "\" data-installer_name=\"").concat((_item$data$name2 = item['data']['name']) !== null && _item$data$name2 !== void 0 ? _item$data$name2 : 'N/A', "\" data-product=\"").concat(productName, "\" class=\"installers-enquire-only-product ").concat(shared_classes, "\" data-view=\"").concat(view, "\">");
        tag_close = '</' + (enquire_only_form ? 'button type="button"' : 'div') + '>';
      } //if this is a legacy installer, link to the product page


      if (item['type'] == 'installer') {
        //if we have a product URL for this product
        if (product_urls[productName]) {
          //switch the tags to link to the product page
          tag_open = "<a href=\"".concat(product_urls[productName], "\" target=\"_blank\" rel=\"noopener\" class=\"").concat(shared_classes, "\">");
          tag_close = '</a>';
        } else {
          //otherwise...
          //just use a div
          tag_open = "<div class=\"".concat(shared_classes, "\">");
          tag_close = '</div>';
        }
      }

      return "\n                                ".concat(tag_open, "\n                                    <img src=\"").concat(product_images[productName], "\" class=\"mx-auto object-contain h-[70%] mb-2\" />\n                                    <span class=\"block text-[11px] leading-[26px] bg-black text-white text-center w-full max-w-[111px] mx-auto rounded-full\">\n                                        ").concat(details.label, "\n                                    </span>\n                                ").concat(tag_close, "\n                            ");
    }

    return '';
  }).join(''), "\n\n                </div>"), "\n\n            </div>\n        </div>\n    ");
}

function hide_markers() {
  //wrap in a try/catch to prevent errors
  try {
    //loop through the markers
    for (var i = 0; i < markers.length; i++) {
      //if the map bounds contain the marker position
      if (window.installer_map.getBounds().contains(markers[i].getPosition())) {
        //set the map to the marker
        markers[i].setMap(window.installer_map);
      } else {
        //if the map bounds don't contain the marker position
        //set the map to null
        markers[i].setMap(null);
      }
    } //if pin grouping is enabled


    if (window.installer_map_pin_grouping) {
      //regroup the markers
      group_markers();
    }
  } catch (e) {//ignore the error
  }
}

function group_markers() {
  // Remove any existing clusters before applying new ones
  if (window.installer_markerClusterer) {
    window.installer_markerClusterer.clearMarkers();
    window.installer_markerClusterer = null;
  }

  window.installer_markerClusterer = new MarkerClusterer({
    map: window.installer_map,
    markers: window.installer_markers,
    renderer: {
      render: function render(_ref3) {
        var count = _ref3.count,
            position = _ref3.position;
        return new google.maps.Marker({
          position: position,
          icon: {
            url: installers_script_vars.theme_path + '/graphics/installers/pin-group.svg',
            scaledSize: new google.maps.Size(70, 70)
          },
          label: {
            text: String(count),
            color: "#fff",
            fontSize: "16px",
            fontWeight: "bold"
          },
          zIndex: 1000 + count
        });
      }
    }
  });
}

function init_quote_handler() {
  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('installers-loading-toggle')) return; //toggle our loader

    toggle_loader('default');
  });
  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('installers-product-quote-menu')) return; //if the menu is already open...

    if (event.target.classList.contains('quote-menu-active')) {
      //close it
      event.target.classList.remove('quote-menu-active');
    } else {
      //find any open menus
      var open_menus = document.querySelectorAll('.installers-product-quote-menu.quote-menu-active'); //loop through each open menu

      open_menus.forEach(function (menu) {
        //close the menu
        menu.classList.remove('quote-menu-active');
      }); //open this menu

      event.target.classList.add('quote-menu-active');
    }
  }); //adds a click event listener to the document

  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('installers-request-quote')) return; //attempt to find our quote ID from the URL

    var urlParams = new URLSearchParams(window.location.search);
    var quote_id = urlParams.get('quote'); //attempt to fetch our installer ID

    var installer_id = event.target.dataset.id;

    if (installer_id) {
      //attempt to fetch the view we're rendering
      var view = event.target.dataset.view;
      var _endpoint = false;

      if (view) {
        switch (view) {
          case 'map':
            //fetch the map element
            view = document.getElementById('installersMap');
            break;

          case 'list':
            //fetch the list element
            view = document.getElementById('installersList');
            break;
        } //fetch the endpoint from the specified view


        _endpoint = view.dataset.quote_endpoint;
      } //if we have a quote ID


      if (quote_id) {
        //create a new xhr
        var xhttp = new XMLHttpRequest(); //when the request state changes

        xhttp.onreadystatechange = function () {
          //if our request is complete
          if (this.status === 200) {
            //default to no response
            var response = false; //try...

            try {
              //... to parse the response
              response = JSON.parse(xhttp.responseText); //fetch our confirmation page

              var confirmation = document.getElementById('quote-confirmation');
              var confirmation_date = confirmation.querySelector('#installer-quote-confirmation-date');
              var confirmation_id = confirmation.querySelector('#installer-quote-confirmation-quote-id');
              var confirmation_logo = confirmation.querySelector('#installer-quote-confirmation-logo');
              var confirmation_approved = confirmation.querySelector('#installer-quote-confirmation-approved'); //fetch our email/phone

              var installer_phone = confirmation.querySelector('#installer-quote-confirmation-phone');
              var installer_email = confirmation.querySelector('#installer-quote-confirmation-email'); //if we have a confirmation modal

              if (confirmation) {
                //add the active class, showing the confirmation
                confirmation.classList.add('active'); //pop the state without reloading the page

                history.pushState({}, '', window.location.pathname + '?quote=' + quote_id);
              } //if we have a response time


              if (response.time && confirmation_date) {
                //update the response time
                confirmation_date.innerHTML = response.time;
              } //if we have a response reference


              if (response.reference && confirmation_date) {
                //update the response time
                confirmation_id.innerHTML = 'Quote ID Number: ' + response.reference;
              } //if we have a response and it contains an phone number


              if (installer_phone && response.installer.phone) {
                //set the href
                installer_phone.href = 'tel:' + response.installer.phone; //find the last span child and add the phone number to it

                installer_phone.children[1].innerHTML = response.installer.phone; //show the phone number

                installer_phone.classList.remove('hidden');
              } else {
                //remove the phone number
                installer_phone.href = '';
                installer_phone.children[1].innerHTML = ''; //hide the phone number

                installer_phone.classList.add('hidden');
              } //if we have a response and it contains an email


              if (installer_email && response.installer.email) {
                //set the href
                installer_email.href = 'mailto:' + response.installer.email; //find the last span child and add the email to it

                installer_email.children[1].innerHTML = response.installer.email; //show the email

                installer_email.classList.remove('hidden');
              } else {
                //remove the email
                installer_email.href = '';
                installer_email.children[1].innerHTML = ''; //hide the email

                installer_email.classList.add('hidden');
              } //if we have a response and it contains a logo


              if (response.installer.logo && confirmation_logo) {
                //update the logo
                confirmation_logo.src = response.installer.logo;
              } else {
                //remove the logo
                confirmation_logo.src = '';
              } //check if we have any existing quotes


              check_existing_quotes(); //disable the loader

              disable_loader();
            } catch (error) {
              //if there's an error...
              //ignore it, we don't need to do anything
              disable_loader();
            }
          } else if (this.response === 400) {
            //check if a toast is already being displayed
            if (!document.querySelector('.toastify')) {
              //display a error message to the user
              Toastify({
                text: "There was an issue requesting your quote. Please try again.",
                duration: 5000,
                gravity: "bottom",
                position: "center",
                stopOnFocus: true,
                className: "!bg-red"
              }).showToast();
            }

            disable_loader();
          }
        }; //enable the loader


        toggle_loader('default'); //open the request

        xhttp.open("GET", _endpoint + '?quote=' + quote_id + '&installer=' + installer_id, true); //send the request

        xhttp.send();
      }
    } else {
      //display a error message to the user
      Toastify({
        text: "You've already requested a quote from this installer.",
        duration: 5000,
        gravity: "bottom",
        position: "center",
        stopOnFocus: true,
        className: "!bg-red"
      }).showToast();
    }
  }); //adds a click event listener to the document

  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('close-quote')) return; //fetch our confirmation page

    var confirmation = document.getElementById('quote-confirmation'); //if we have a confirmation modal

    if (confirmation) {
      //add the active class, showing the confirmation
      confirmation.classList.remove('active');
    }
  }); //adds a click event listener to the document

  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('open-installer-quote-prompt')) return; //fetch our prompt

    var prompt = document.getElementById('installer-quote-prompt'); //if we have a confirmation modal

    if (prompt) {
      //reveal the prompt
      prompt.classList.remove('hidden');
    }
  }); //adds a click event listener to the document

  document.addEventListener("click", function (event) {
    //if the target doesn't have the class we're looking for, return
    if (!event.target.classList.contains('close-installer-quote-prompt')) return; //fetch our prompt

    var prompt = document.getElementById('installer-quote-prompt'); //if we have a confirmation modal

    if (prompt) {
      //hide the prompt
      prompt.classList.add('hidden');
    }
  }); //adds a form submit handler for the manual search form

  document.addEventListener("submit", function (event) {
    if (!event.target.classList.contains('installer-manual-search')) return; //prevent the default form submission

    event.preventDefault(); //get installers

    get_installers(event.target);
  });

  window.onpopstate = function () {
    return setTimeout(function () {
      var confirmation = document.getElementById('quote-confirmation');

      if (confirmation && confirmation.classList.contains('active')) {
        confirmation.classList.remove('active');
        return;
      }
    }, 0);
  };
}

function check_existing_quotes() {
  var _document$getElementB;

  var cached = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var now = Date.now(); // Prevent this from running more than once every second

  if (now - lastCheckTime < 1000) {
    return;
  }

  lastCheckTime = now; //attempt to find our quote ID from the URL

  var urlParams = new URLSearchParams(window.location.search);
  var quote_id = urlParams.get('quote'); //if we don't have a quote ID

  if (!quote_id) {
    //disable the loader
    disable_loader(); //bail

    return;
  } //if we're using the cached version


  if (cached) {
    //fetch the cached quotes
    var quotes = localStorage.getItem('quotes'); //if we have quotes

    if (quotes) {
      //parse the quotes
      apply_existing_quotes(JSON.parse(quotes)); //bail

      return;
    }
  } //default our endpoint to false


  var endpoint = false; //fetch the view element

  var view = (_document$getElementB = document.getElementById('installersMap')) !== null && _document$getElementB !== void 0 ? _document$getElementB : document.getElementById('installersList'); //if we have a view

  if (view) {
    //fetch the endpoint from the specified view
    endpoint = view.dataset.existing_quotes_endpoint;
  } //if we don't have an endpoint at this stage


  if (!endpoint) {
    //disable the loader
    disable_loader(); //bail

    return false;
  } //create a new xhr


  var xhttp = new XMLHttpRequest(); //when the request state changes

  xhttp.onreadystatechange = function () {
    //if our request is complete
    if (this.status === 200) {
      //try...
      try {
        //parse the response
        var _quotes = JSON.parse(xhttp.responseText); //store this response in the cache


        localStorage.setItem('quotes', JSON.stringify(_quotes)); //apply the existing quotes

        apply_existing_quotes(_quotes); //disable the loader

        disable_loader();
      } catch (error) {
        //if there's an error...
        //ignore it, we don't need to do anything
        //disable the loader
        disable_loader();
      }
    }
  }; //open the request


  xhttp.open("GET", endpoint + '?quote=' + quote_id, true); //send the request

  xhttp.send();
}

function apply_existing_quotes(quotes) {
  //if we have some quotes already
  if (quotes && quotes.length > 0) {
    //loop over the quotes
    for (var i = 0; i < quotes.length; i++) {
      //store the quote
      var quote = quotes[i]; //check to see if there's a logo available

      var logo = document.querySelector('.installers-request-logo[data-id="' + quote['installer']['id'] + '"]'); //check to see if there's a button to disable

      var button = document.querySelector('.installers-request-quote[data-id="' + quote['installer']['id'] + '"]'); //check to see if we have any confirmation elements

      var confirmation = document.querySelector('.installers-quote-confrmation[data-id="' + quote['installer']['id'] + '"]'); //check to see if we have any quote confirmation elements

      var confirmation_quote = document.querySelector('.installers-quote-id[data-id="' + quote['installer']['id'] + '"]'); //default this to false initially, if we can find it we'll update it

      var list_item = false; //try to find the list item

      try {
        //fetch the list item
        list_item = button.closest('.installers-list-item');
      } catch (e) {//otherwise it can't be found
      } //if we have a button


      if (button) {
        //change the button text
        button.innerHTML = 'Quote Request Sent'; //remove the installer id

        button.removeAttribute('data-id'); //make it visually different

        button.classList.add('!bg-[#DBDBDB]');
        button.classList.add('!border-[#DBDBDB]');
        button.classList.add('!text-[#919191]');
        button.classList.add('pointer-events-none');
        button.classList.add('select-none');
      } //if we have a confirmation element


      if (confirmation) {
        //remove the installer id
        confirmation.removeAttribute('data-id'); //add the confirmation text

        confirmation.innerHTML = (!list_item ? "<div class=\"opacity-75\">" : '') + "Successfully requested on: <strong class=\"block\">" + quote.time + "</strong>" + (!list_item ? "</div>" : ''); //if we don't have a confirmation quote

        if (!confirmation_quote) {
          //add our quote ID here instead
          confirmation.innerHTML += "<div class=\"mt-2" + (!list_item ? " opacity-75" : '') + "\">Quote ID Number: <strong class=\"block\">" + quote.reference + "</strong></div>";
        } //if this is a list item


        if (list_item) {
          //add responsive classes
          confirmation.parentNode.classList.add('w-full');
          confirmation.parentNode.classList.add('xl:w-auto');
          confirmation.parentNode.classList.add('!mt-2');
          confirmation.parentNode.classList.add('xl:!mt-0');
        } //indicate it's been confirmed


        confirmation.classList.add('active');
      } //if we have a confirmation quote element


      if (confirmation_quote) {
        //remove the installer id
        confirmation_quote.removeAttribute('data-id'); //add the quote confirmation text

        confirmation_quote.innerHTML = "<div>Quote ID Number: <strong class=\"block\">" + quote.reference + "</strong></div>"; //if this is a list item

        if (list_item) {
          //make responsiveness changes to the parent item
          confirmation_quote.classList.remove('flex-1');
          confirmation_quote.classList.add('xl:flex-1');
          confirmation_quote.classList.remove('!mt-0');
          confirmation_quote.classList.add('!mt-2');
          confirmation_quote.classList.add('xl:!mt-0');
        }
      } //if we have a list item that's not already been disabled


      if (list_item && !list_item.classList.contains('opacity-50')) {
        //visually indicate it's inactive
        list_item.classList.add('opacity-50');
        list_item.classList.add('border-opacity-50');
      } //if we have some map markers


      if (markers && markers.length > 0) {
        //loop over our map markers
        for (var ii = 0; ii < markers.length; ii++) {
          //if the installer ID matches the quote installer ID
          if (parseInt(markers[ii]['installerId']) === parseInt(quote['installer']['id'])) {
            //change the default icon
            markers[ii].setIcon({
              url: installers_script_vars.theme_path + '/graphics/installers/pin-quoted.svg',
              scaledSize: new google.maps.Size(28, 43)
            }); //force the map to update

            markers[ii].setMap(window.installer_map);
          }
        }
      }
    }
  }
}

function open_no_results() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  //fetch the no results modal
  var no_results = document.getElementById('installers-no-results'); //if we have a no results modal

  if (no_results) {
    //fetch the alt message element
    var alt_message = document.getElementById('installers-no-results-alt-message'); //if we have an alt message element

    if (alt_message) {
      //wipe it
      alt_message.innerHTML = '';
      alt_message.classList.add('hidden'); //if we have a message to display

      if (message) {
        //add the message
        alt_message.innerHTML = message; //show the message

        alt_message.classList.remove('hidden');
      }
    } //remove the hidden classes


    no_results.classList.remove('opacity-0');
    no_results.classList.remove('invisible'); //fetch the message itself

    var no_results_message = document.querySelector('#installers-no-results > div'); //if we have a message

    if (no_results_message) {
      //remove the opacity and scale classes
      no_results_message.classList.remove('opacity-0');
      no_results_message.classList.remove('scale-75');
    }
  }
}

function close_no_results() {
  //fetch the no results modal
  var no_results = document.getElementById('installers-no-results'); //if we have a no results modal

  if (no_results) {
    //restore the hidden classes
    no_results.classList.add('opacity-0');
    no_results.classList.add('invisible'); //fetch the message itself

    var no_results_message = document.querySelector('#installers-no-results > div'); //if we have a message

    if (no_results_message) {
      //remove our delay class so both elements animate together
      no_results_message.classList.remove('delay-150'); //add the opacity and scale classes

      no_results_message.classList.add('opacity-0');
      no_results_message.classList.add('scale-75'); //wait for the animation to complete...

      setTimeout(function () {
        //restore the delayed class
        no_results_message.classList.add('delay-150'); //fetch the alt message element

        var alt_message = document.getElementById('installers-no-results-alt-message'); //if we have an alt message element

        if (alt_message) {
          //reset it
          alt_message.innerHTML = '';
          alt_message.classList.add('hidden');
        }
      }, 300);
    }
  }
}

function open_enquire(installer_id, installer_name, product) {
  //fetch the enquire modal, its form container and the inner form
  var enquire = document.getElementById('installers-enquire-only');
  var form_container = document.querySelector('#installers-enquire-only > div');
  var form = form_container.querySelector('form'); //if we have a enquire modal

  if (enquire && form_container && form) {
    //identify our form fields
    var installer_id_field = form.querySelector('input[name="installer_id"]');
    var installer_name_field = form.querySelector('input[name="installer_name"]');
    var product_selector = form.querySelector('select[name="product"]'); //if we have an installer ID field

    if (installer_id_field) {
      //set the installer ID
      installer_id_field.value = installer_id;
    } //if we have an installer name field


    if (installer_name_field) {
      //set the installer name
      installer_name_field.value = installer_name;
    } //if we have a product selector


    if (product_selector) {
      //set the product
      product_selector.value = product; //trigger a change event

      var event = new Event('change');
      product_selector.dispatchEvent(event);
    } //remove the hidden classes


    enquire.classList.remove('opacity-0');
    enquire.classList.remove('invisible'); //animate it in

    form_container.classList.remove('opacity-0');
    form_container.classList.remove('scale-75');
  }
}

function close_enquire() {
  //fetch the enquire modal and its form container
  var enquire = document.getElementById('installers-enquire-only');
  var form_container = document.querySelector('#installers-enquire-only > div'); //if we have a enquire modal

  if (enquire && form_container) {
    //restore the hidden classes
    enquire.classList.add('opacity-0');
    enquire.classList.add('invisible');
    form_container.classList.add('opacity-0');
    form_container.classList.add('scale-75');
  }
}